import { InjectionToken, ValueProvider } from '@angular/core';
import * as fb from 'firebase/app';
import 'firebase/auth';
import 'firebase/storage';

const Firebase = new InjectionToken('firebase');
const FirebaseProvider: ValueProvider = { provide: Firebase, useValue: fb };
export { Firebase, FirebaseProvider };
